import PolicyListing from "../../../Components/Policy/PolicyListing";

export default function PolicyListings() {
    return (
        
        <PolicyListing />
    )
}